import { fetchLibraDietApiData } from './apiData'
import { localizePath, initRequestOptions } from '../utils/api'

const path = '/intakes'

export const intakesShow = (locale, accessToken, id) => (dispatch) => {
	const endpoint = localizePath(locale, `${path}/${id}`)
	const options = initRequestOptions({ accessToken })

	return dispatch(fetchLibraDietApiData({ endpoint, options }))
}
